import { FC } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { parse } from 'date-fns';

import {
  StaticDateSpan,
  Table,
  TableBody,
  TableBodyCell,
  TableContainer,
  TableHead,
  TableHeaderCell,
  TableRow,
} from '@myn/mui';

import { Version } from '../../../types/versions.js';
import { SERVER_DATE_FORMAT } from '../../Co2NotificationRow/Co2NotificationRow.constnts.jsx';

type IDateRangeProps = {
  item: Version;
};

const DateRange: FC<IDateRangeProps> = ({ item }) => {
  const { t } = useTranslation('@myn/planning');

  const { dateFrom, dateTo } = item.channelMixVersionData?.dateRange || {};
  const startDate = dateFrom
    ? parse(dateFrom, SERVER_DATE_FORMAT, new Date())
    : null;
  const endDate = dateTo ? parse(dateTo, SERVER_DATE_FORMAT, new Date()) : null;

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableHeaderCell>{t('Start date')}</TableHeaderCell>
            <TableHeaderCell sx={{ justifyItems: 'flex-end' }}>
              {t('End date')}
            </TableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableBodyCell>
              {startDate ? <StaticDateSpan date={startDate} /> : '-'}
            </TableBodyCell>
            <TableBodyCell align="right">
              {endDate ? <StaticDateSpan date={endDate} /> : '-'}
            </TableBodyCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DateRange;
